import { useEffect, useState } from 'react';
import { newsList } from '@/mocks/ranking';
import SectionHeading from './SectionHeading';

const quickChips = ['综艺', '萌宠', '塌房', '榜单', '考古'];

export default function NewsSection() {
  const [query, setQuery] = useState('');
  const [fav, setFav] = useState<Record<number, boolean>>({});

  useEffect(() => {
    const onSearch = (e: Event) => {
      const detail = (e as CustomEvent).detail as { query?: string } | undefined;
      if (detail?.query) setQuery(detail.query);
    };
    window.addEventListener('chigua:search', onSearch);
    return () => window.removeEventListener('chigua:search', onSearch);
  }, []);

  const q = query.trim().toLowerCase();
  const list = q ? newsList.filter((n) => `${n.title}${n.summary}${n.tag}`.toLowerCase().includes(q)) : newsList;

  const toggleFav = (id: number) => setFav((f) => ({ ...f, [id]: !f[id] }));

  return (
    <section id="news" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="有料的瓜点 · 值得慢慢吃"
          title="瓜点速递"
          desc="榜单背后的深度观察与选题故事，换个角度把瓜吃明白。想看哪类，点一下下面的标签快速筛选。"
        />

        {/* quick chips + result */}
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <div className="flex flex-wrap gap-2">
            {quickChips.map((c) => (
              <button
                key={c}
                onClick={() => setQuery(query === c ? '' : c)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                  query === c
                    ? 'bg-primary-500 text-background-50'
                    : 'border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300'
                }`}
              >
                #{c}
              </button>
            ))}
          </div>
          {q && (
            <span className="text-xs text-foreground-500">
              共找到 <b className="text-primary-600">{list.length}</b> 篇关于「{query}」的内容
              {list.length === 0 && (
                <button onClick={() => setQuery('')} className="ml-2 text-secondary-600 underline underline-offset-2">
                  清空筛选
                </button>
              )}
            </span>
          )}
        </div>

        {list.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-background-300 bg-background-50 p-10 text-center">
            <i className="ri-search-eye-line text-4xl text-foreground-300" />
            <p className="mt-3 text-foreground-500">暂时没有匹配「{query}」的瓜点，换个关键词试试。</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {list.map((n) => (
              <article key={n.id} className="group flex flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={n.cover}
                    alt={`${n.tag}：${n.title}`}
                    title={`吃瓜榜单瓜点速递 · ${n.title}`}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <button
                    onClick={() => toggleFav(n.id)}
                    className={`absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full backdrop-blur transition-colors ${
                      fav[n.id] ? 'bg-primary-500 text-background-50' : 'bg-background-50/80 text-foreground-700 hover:bg-background-50'
                    }`}
                    aria-label="收藏"
                  >
                    <i className={`${fav[n.id] ? 'ri-bookmark-fill' : 'ri-bookmark-line'} text-base leading-none`} />
                  </button>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                      <i className="ri-price-tag-3-line text-xs leading-none" />
                      {n.tag}
                    </span>
                    <span className="text-xs text-foreground-400">
                      <i className="ri-eye-line mr-1 leading-none" />
                      {n.reads}
                    </span>
                  </div>
                  <h3 className="mt-3 line-clamp-2 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {n.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{n.summary}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                      <i className="ri-time-line leading-none" />
                      编辑精选
                    </span>
                    <a
                      href="#hotlist"
                      className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700"
                    >
                      去榜单支持它上榜
                      <i className="ri-arrow-right-line text-sm leading-none" />
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}